<template>
  <WebhookForm :id="id" :initial="effectiveInitial" :visibility-config="visibilityConfig" @saved="$emit('saved')">
    <template #parameters="{ getSecret, setSecret, getParam, setParam }">
      <div class="box">
        <h2 class="subtitle">{{ $t('lastfm.settings') }}</h2>

        <BFieldHint :label="$t('lastfm.user')" hintKey="">
          <b-input
            :model-value="getParam('USER')"
            :placeholder="$t('lastfm.userPlaceholder')"
            @update:model-value="val => setParam('USER', val)"
          />
        </BFieldHint>

        <BFieldHint :label="$t('lastfm.apiKey')" hintKey="">
          <b-select :model-value="getSecret('LASTFM_API_KEY')"
                    :placeholder="$t('lastfm.selectSecret')"
                    @update:model-value="val => setSecret('LASTFM_API_KEY', String(val))">
            <option v-for="name in secretOptions" :key="name" :value="name">{{ name }}</option>
          </b-select>
        </BFieldHint>
      </div>
    </template>
  </WebhookForm>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue'
import WebhookForm from '@/views/templates/WebhookForm.vue'
import BFieldHint from '@/components/BFieldHint.vue'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'LastfmForm',
  components: { WebhookForm, BFieldHint },
  props: {
    id: String,
    initial: Object as PropType<Record<string, unknown>>
  },
  emits: ['saved'],
  setup(props) {
    const store = useStore()
    const secretOptions = computed<string[]>(() => {
      const s: any = store.state.secrets || []
      const list = Array.isArray(s) ? s : Object.values(s)
      return list.map((x: any) => String(x.name)).filter(Boolean)
    })

    const defaultInitial = {
      name: '',
      event: 'lastfm-data',
      template: 'lastfm',
      url: 'http://ws.audioscrobbler.com/2.0/',
      requestType: 'GET',
      noDefaults: true,
      rejectUnauthorized: true,
      unchunked: false,
      data_url_response_event: false,
      query: {
        method: 'user.getrecenttracks',
        format: 'json',
        user: '{{{USER}}}',
        api_key: '{{{LASTFM_API_KEY}}}',
        limit: 1
      },
      responseTemplate: '{{#recenttracks}}{{#track.0}}{{#@attr.nowplaying}}1{{{artist.#text}}} - {{{name}}}{{/@attr.nowplaying}}{{^@attr.nowplaying}}0{{/@attr.nowplaying}}{{/track.0}}{{/recenttracks}}'
    } as Record<string, unknown>

    const effectiveInitial = computed<Record<string, unknown>>(() => {
      return (props.initial as any) || defaultInitial
    })
    
    const visibilityConfig = {
      jsonTab: false,
      secrets: false,
      requestURL: false,
      requestType: false,
      requestFormat: false,
      queryParams: false,
      httpHeaders: false,
      httpBasicAuth: false,
      responseTemplate: false
    }
    
    return { secretOptions, effectiveInitial, visibilityConfig }
  }
})
</script>
